<template>
  <div>
    <ConfirmDialog
      :dialog="showConfirmClose"
      @modalResult="confirmCloseTicketDialogResult"
      title="Close this ticket?"
      text="Closed tickets cannot be commented on and cannot be reopened."
      yesColor="amber"
    >
    </ConfirmDialog>

    <ConfirmDialog
      :dialog="showConfirmEscalate"
      @modalResult="confirmEscalateTicketDialogResult"
      title="Escalate this ticket?"
      text="Escalated tickets will generate e-mails to engineering."
      yesColor="amber"
    >
    </ConfirmDialog>

    <ConfirmDialog
      :dialog="showConfirmDeescalate"
      @modalResult="confirmDeescalateTicketDialogResult"
      title="De-escalate this ticket?"
      text="De-escalated tickets will no longer generate e-mails to engineering."
      yesColor="amber"
    >
    </ConfirmDialog>

    <TicketDetailDialog
      :dialog="showTicketDetailDialog"
      :ticket="ticket"
      @close="closeTicketDetailDialog"
    >
    </TicketDetailDialog>

    <CreateCommentDialog
      :dialog="showCreateCommentDialog"
      :ticketId="ticket.id"
      :comments="ticket.comments"
      @close="closeCreateCommentDialog"
    >
    </CreateCommentDialog>

    <v-card>
      <v-toolbar
        color="amber"
      >
        <v-toolbar-title>
          Support Tickets
        </v-toolbar-title>

        <div class="flex-grow-1"></div>

        <v-checkbox
         v-model="showOnlyMyTickets"
         label="Only My Tickets"
         class="mt-6 mr-3"
         @change="showOnlyMyTicketsChanged"
        >
        </v-checkbox>

        <v-checkbox
          v-model="showClosedTickets"
          label="Include Closed Tickets"
          class="mt-6 mr-3"
          @change="showClosedTicketsChanged"
        >
        </v-checkbox>

        <div style="width:250px">
          <v-text-field
            placeholder="filter serial number"
            single-line
            v-model="filterSerialNumber"
            append-icon="filter_list"
            style="width:200px"
            class="mt-4 mr-3"
            @input="filter"
          >
          </v-text-field>
        </div>
      </v-toolbar>

      <v-data-table
        class="mt-5"
        single-select
        :footer-props="{ disableItemsPerPage: true, showFirstLastPage: true, showCurrentPage: true  }"
        :headers="headers"
        :loading="busy"
        :items="tickets"
        :items-per-page="10"
        :server-items-length="serverItemsLength"
        :options.sync="options"
      >
        <template v-slot:item.action="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon small class="mr-2" @click.stop="loadAndShowTicketDetailDialog(item)" v-on="on">zoom_in</v-icon>
            </template>
            <span>View Ticket Details</span>
            <p style="width:300px;margin-bottom:3px;">{{item.description}}</p>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon small class="mr-2" v-if="item.status === 'open'" @click.stop="openCreateCommentDialog(item)" v-on="on">comment</v-icon>
            </template>
            <span>Add Ticket Comment</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon small class="mr-2" style="color:red;" v-if="item.status === 'open' && item.escalated === false" @click.stop="openConfirmEscalateTicketDialog(item)" v-on="on">report</v-icon>
            </template>
            <span>Escalate</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon small class="mr-2" v-if="item.status === 'open' && item.escalated === true" @click.stop="openConfirmDeescalateTicketDialog(item)" v-on="on">report_off</v-icon>
            </template>
            <span>De-escalate</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon small class="mr-2" v-if="item.status === 'open'" @click.stop="openConfirmCloseTicketDialog(item)" v-on="on">done_outline</v-icon>
            </template>
            <span>Close Ticket</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import moment from 'moment';
import ConfirmDialog from '../components/ConfirmDialog.vue';
import TicketDetailDialog from '../components/support_tickets/TicketDetailDialog.vue';
import CreateCommentDialog from '../components/support_tickets/CreateCommentDialog.vue';

export default {
  components: {
    ConfirmDialog,
    TicketDetailDialog,
    CreateCommentDialog,
  },

  data() {
    return {
      showOnlyMyTickets: false,
      showClosedTickets: false,
      headers: [
        {
          text: 'ID',
          align: 'left',
          sortable: false,
          value: 'id',
          width: 150,
        },
        {
          text: 'Serial Number',
          align: 'left',
          sortable: false,
          value: 'serialNumber',
          width: 150,
        },
        {
          text: 'Status',
          align: 'left',
          sortable: false,
          value: 'status',
          width: 75,
        },
        {
          text: 'Opened At',
          align: 'left',
          sortable: false,
          value: 'createdAt',
          width: 175,
        },
        {
          text: 'Opened By',
          align: 'left',
          sortable: false,
          value: 'issuerUsername',
          width: 125,
        },
        {
          text: 'Closed By',
          align: 'left',
          sortable: false,
          value: 'closedByUsername',
          width: 125,
        },
        {
          text: 'Caller\'s Name',
          align: 'left',
          sortable: false,
          value: 'originatorName',
          width: 200,
        },
        {
          text: 'Actions',
          align: 'left',
          sortable: false,
          value: 'action',
        },
      ],
      options: {},
      busy: false,
      serverItemsLength: 0,
      tickets: [],
      filterSerialNumber: '',
      ticket: {},
      showConfirmClose: false,
      showConfirmEscalate: false,

      showConfirmDeescalate: false,

      showTicketDetailDialog: false,
      showCreateCommentDialog: false,
    };
  },

  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },

  mounted() {
    this.getData();
  },

  methods: {
    showOnlyMyTicketsChanged() {
      this.getData();
    },

    showClosedTicketsChanged() {
      this.getData();
    },

    getData() {
      const options = {
        method: 'get',
        url: `/read/tickets/v1/?page=${this.options.page || 1}&filterSerialNumber=${this.filterSerialNumber}&closed=${this.showClosedTickets}&mine=${this.showOnlyMyTickets}&username=${this.$store.state.auth.token.user.username}`,
      };

      this.busy = true;
      return this.axios(options)
        .then((res) => {
          this.busy = false;
          this.serverItemsLength = res.data.totalDocs;
          this.tickets = res.data.docs.map((cur) => {
            const { createdAt, ...rest } = cur;
            const created = moment(createdAt);
            return Object.assign({}, { createdAt: created.local().format('YYYY-MM-DD HH:mm:ss') }, rest);
          });
        })
        .catch((err) => {
          this.busy = false;
        });
    },

    filter() {
      this.getData();
    },

    openConfirmEscalateTicketDialog(ticket) {
      this.ticket = ticket;
      this.showConfirmEscalate = true;
    },

    confirmEscalateTicketDialogResult(confirmed) {
      if (confirmed) {
        const options = {
          method: 'post',
          url: '/update/ticket_escalated/v1/',
          data: {
            id: this.ticket.id,
          },
        };

        this.busy = true;

        this.axios(options)
          .then((res) => {
            this.showConfirmEscalate = false;
            this.ticket = {};

            this.getData();
          });
      } else {
        this.showConfirmEscalate = false;
        this.ticket = {};
      }
    },

    openConfirmDeescalateTicketDialog(ticket) {
      this.ticket = ticket;
      this.showConfirmDeescalate = true;
    },

    confirmDeescalateTicketDialogResult(confirmed) {
      if (confirmed) {
        const options = {
          method: 'post',
          url: '/update/ticket_deescalated/v1/',
          data: {
            id: this.ticket.id,
          },
        };

        this.busy = true;

        this.axios(options)
          .then((res) => {
            this.showConfirmDeescalate = false;
            this.ticket = {};

            this.getData();
          });
      } else {
        this.showConfirmDeescalate = false;
        this.ticket = {};
      }
    },

    openConfirmCloseTicketDialog(ticket) {
      this.ticket = ticket;
      this.showConfirmClose = true;
    },

    confirmCloseTicketDialogResult(confirmed) {
      if (confirmed) {
        const options = {
          method: 'post',
          url: '/update/ticket_closed/v1/',
          data: {
            id: this.ticket.id,
            username: this.$store.state.auth.token.user.username,
          },
        };

        this.busy = true;

        this.axios(options)
          .then((res) => {
            this.showConfirmClose = false;
            this.ticket = {};

            this.getData();
          });
      } else {
        this.showConfirmClose = false;
        this.ticket = {};
      }
    },

    loadAndShowTicketDetailDialog(ticketToFetch) {
      const options = {
        method: 'get',
        url: `/read/ticket/v1/?id=${ticketToFetch.id}`,
      };

      this.busy = true;

      this.axios(options)
        .then((res) => {
          this.busy = false;

          this.ticket = res.data;
          this.showTicketDetailDialog = true;
        });
    },

    closeTicketDetailDialog() {
      this.ticket = {};
      this.showTicketDetailDialog = false;
    },

    openCreateCommentDialog(ticketToFetch) {
      const options = {
        method: 'get',
        url: `/read/ticket/v1/?id=${ticketToFetch.id}`,
      };

      this.busy = true;

      this.axios(options)
        .then((res) => {
          this.busy = false;

          this.ticket = res.data;
          this.showCreateCommentDialog = true;
        });
    },

    closeCreateCommentDialog({ text }) {
      if (text !== null && text !== '') {
        this.busy = true;

        const options = {
          method: 'post',
          url: '/create/comment/v1/',
          data: {
            ticketId: this.ticket.id,
            authorUsername: this.$store.state.auth.token.user.username,
            text,
          },
        };

        this.axios(options)
          .then((res) => {
            this.ticket.comments.push(res.data);
            this.showCreateCommentDialog = false;
            this.busy = false;
          })
          .catch((err) => {
            this.showCreateCommentDialog = false;
            this.busy = false;
          });
      } else {
        this.showCreateCommentDialog = false;
      }
    },
  },
};
</script>

<style scoped>
</style>
